module.exports = "/images/watch-2.jpg?79b561e9b2902709b9d1244949e0b9b4";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/assets/images/products/watch-2.jpg
// module id = /2yo
// module chunks = 35